import styles from '../businessProcess/businessProcess.module.css';
import {
  type BusinessProcessFlow,
  businessProcessFlows,
} from '../businessProcess/definitions';
import flowIcons from '../businessProcess/flowIcons/icons';
import type WhiteboardController from '../controllers/WhiteboardController';
import { svgToIcon } from '../utils/svg';
import ConnectorDrawingBrush from './ConnectorDrawingBrush';
import Stylus from './Stylus';

class StylusFlow extends Stylus {
  flow: BusinessProcessFlow;

  constructor({
    controller,
    flowId,
  }: {
    controller: WhiteboardController;
    flowId: string;
  }) {
    super({ controller });

    const flow = businessProcessFlows.find(flow => flow.id === flowId);
    if (!flow) {
      throw new Error(`Flow with id ${flowId} not found`);
    }
    this.flow = flow;
  }

  activate() {
    const brush = new ConnectorDrawingBrush(
      this.controller.canvas,
      this.flow.options
    );
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  stylusId() {
    return `flow-${this.flow.id}`;
  }

  toolButtonClass() {
    return styles.businessProcessLargeButton;
  }

  description() {
    return this.flow.name ?? '';
  }

  renderIcon() {
    return svgToIcon(flowIcons[this.flow.id]);
  }
}

export default StylusFlow;
